'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var react = require('@chakra-ui/react');
var toast = require('./toast.js');
var React = require('react');
var toast_provider = require('./toast.provider.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

// Chakra overwrite: changed description of 'position' and 'isClosable' according to changed defaults.

/**
 * React hook used to create a function that can be used
 * to show toasts in an application.
 */
function useToast(options) {
  var _useChakra = react.useChakra(),
    theme = _useChakra.theme;
  var defaultOptions = toast_provider.useToastOptionContext();
  return React.useMemo(function () {
    return toast.createToastFn(theme.direction, _objectSpread(_objectSpread({}, defaultOptions), options));
  }, [options, theme.direction, defaultOptions]);
}
exports["default"] = useToast;
exports.useToast = useToast;